module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-10"
  }, [_c('h2', {
    staticClass: "truncate"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": _vm.jobHref,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.job.number) + "\n            ")])]), _vm._v(" "), (_vm.jobHasEnoughDetails) ? [_vm._v("\n          - " + _vm._s(_vm.job.commodity_and_location_with_public_quantity) + "\n        ")] : _vm._e()], 2)])]), _vm._v(" "), _c('ul', {
    staticClass: "details"
  }, [(_vm.jobHasCoordinator) ? _c('li', [_c('span', [_vm._v("Coordinator:")]), _vm._v(" " + _vm._s(_vm.job.coordinator.profile.full_name) + " " + _vm._s(_vm.job.coordinator.mobile))]) : _c('li', [_c('span', [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-toolbar"
  }, [_c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-job-public-details"
    },
    on: {
      "click": _vm.setActiveJob
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-marker-alt"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-94035cbe"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobBoardListItem.vue
// module id = 1063
// module chunks = 0